import React, { useState } from "react";
import { Modal, Input, List, Checkbox, Avatar, message } from "antd";
import { UsergroupAddOutlined, SearchOutlined } from "@ant-design/icons";
import { chatService } from "../../services/chatService";

const CreateGroupModal = ({ open, onClose, users, currentUserId, onGroupCreated }) => {
  const [groupName, setGroupName] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [search, setSearch] = useState("");

  const handleToggleUser = (user) => {
    if (selectedUsers.some(u => u.id === user.id)) {
      setSelectedUsers(selectedUsers.filter(u => u.id !== user.id));
    } else {
      setSelectedUsers([...selectedUsers, user]);
    }
  };

  const handleCreate = async () => {
    if (!groupName.trim()) {
      return message.error("Please enter a group name");
    }
    if (selectedUsers.length < 1) {
      return message.error("Please select at least one member");
    }

    const members = [
      { id: currentUserId, name: localStorage.getItem("user"), role: 'user' }, // Current user is always member
      ...selectedUsers
    ];

    try {
      const chat = await chatService.createGroup(members, groupName);
      onGroupCreated(chat);
      setGroupName("");
      setSelectedUsers([]);
    } catch (error) {
      console.error("Failed to create group:", error);
      message.error("Failed to create group");
    }
  };

  const filteredUsers = (users || []).filter(u => 
    u.id !== currentUserId && 
    (u.name || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <UsergroupAddOutlined className="text-[#3073f1]" />
          <span>Create Group</span>
        </div>
      }
      open={open}
      onCancel={() => {
        setGroupName("");
        setSelectedUsers([]);
        onClose();
      }}
      onOk={handleCreate}
      okText="Create"
      width={400}
      className="rounded-xl overflow-hidden"
    >
      <div className="flex flex-col gap-4 py-2">
        <div>
          <label className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1 block">Group Name</label>
          <Input 
            placeholder="Enter group name..." 
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            className="rounded-lg py-2"
          />
        </div>

        <div>
          <label className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1 block">Select Members ({selectedUsers.length})</label>
          <Input 
            prefix={<SearchOutlined className="text-gray-400" />}
            placeholder="Search users..." 
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="rounded-lg mb-2"
          />
          <div className="max-h-[300px] overflow-y-auto border rounded-lg bg-gray-50">
            <List
              dataSource={filteredUsers}
              renderItem={(user) => {
                const isSelected = selectedUsers.some(u => u.id === user.id);
                return (
                  <List.Item 
                    className={`px-3 py-2 cursor-pointer hover:bg-white transition-colors ${isSelected ? 'bg-blue-50' : ''}`}
                    onClick={() => handleToggleUser(user)}
                  >
                    <div className="flex items-center gap-3 w-full">
                      <Checkbox checked={isSelected} />
                      <Avatar size="small" className="bg-[#3073f1] font-bold">
                        {user.name?.[0]?.toUpperCase()}
                      </Avatar>
                      <div className="flex flex-col">
                        <span className="text-sm font-medium">{user.name}</span>
                        <span className="text-[10px] text-gray-400 uppercase tracking-tighter">{user.type}</span>
                      </div>
                    </div>
                  </List.Item>
                );
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateGroupModal;
